import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/global.scss'
import ipCheckManager from './utils/ipCheck'

Vue.use(ElementUI)

Vue.config.productionTip = false

// 全局注册 baseUrl
Vue.prototype.$baseUrl = process.env.BASE_URL

// 创建Vue实例前初始化状态
async function initApp() {
  try {
    // 初始化IP检测（优先执行，不阻塞应用启动）
    ipCheckManager.checkAndCacheIp().then(ipInfo => {
      if (ipInfo) {
        // 同步IP信息到Vuex store
        store.commit('SET_IP_INFO', ipInfo)
      }
    }).catch(error => {
      console.error('IP检测初始化失败:', error)
    })
    
    // 初始化认证状态
    await store.dispatch('initAuth')
    // 初始化设备检测
    store.dispatch('initDeviceDetection')
    
    new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  } catch (error) {
    console.error('应用初始化失败:', error)
    // 即使初始化失败，也要启动应用
    new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  }
}

initApp()